import styled from "styled-components";
import {View} from "../../styled-components/View";
import {BodyXLSecondary} from "../../styled-components/Font";
import {BankLinkA} from "../../styled-components/Base";

export const PageWrapper = styled(View)`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

export const MainContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px 0 50px;
`;
export const ContactLinkA= styled.a`
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    color: #59B1FF;
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap:2px;
`
export const InfoText = styled(BodyXLSecondary)`
    color: #1F1F1F;
    margin-bottom: 10px;
    line-height: 1.6;
`;
export const InfoTextTitle = styled(BodyXLSecondary)`
    color: #1F1F1F;
    margin-top: 20px;
    line-height: 1.6;
`;
export const InfoDetailsText = styled.div<{maxWidth?:string}>`
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #787878;
    max-width: ${(props)=>props.maxWidth ? props.maxWidth : '100%' };

    ${BankLinkA}{
        font-size: 18px;
    }
    
    @media screen and (max-width: 768px) {
        max-width: 100%;
    }
    @media screen and (max-width: 440px) {
        flex-direction: column;
    }
`
export const ContentWrapper = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap:10px;
`;
